import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getFunds, putFunds } from './AdminClient';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import LabelledInput from 'Components/Form/LabelledInput';
import Error from 'Components/Form/Error';

function Funds ()
{
    const { currentUser } = useContext ( CurrentUserContext );

    const [ funds, setFunds ] = useState ( null );
    
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ isSubmitting, setIsSubmitting ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    const navigate = useNavigate ();

    useEffect ( () => {

        if ( error.isError === false && isLoading === false && funds === null )
        {
            setIsLoading ( true );

            getFunds ( currentUser )
                .then ( response => {
                    setFunds ( response.data.value )
                    setIsLoading ( false );
                    setError ( { isError: false, message: null } )                    
                } )
                .catch ( error => {
                    setFunds ( null );
                    setIsLoading ( false );
                    setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                } );
        }

    }, [ isLoading, funds ] );
    
    const doSubmit = async () =>
    {
        if ( isSubmitting === false )
        {
            setIsSubmitting ( true );
            
            putFunds ( currentUser, funds )
                .then ( response => {
                    navigate ( "/admin" );
                } )
                .catch ( error => {
                    setIsSubmitting ( false );
                    setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                } );
        }
    }

    return <>
                <h1>Funds</h1>
                { error.isError && <Error message={error.message} /> }
                <LabelledInput label="Total funds raised" id="funds" value={funds} onChange={ ( newValue ) => setFunds ( Number ( newValue ) ) } type="number" editable={true} />
                <div className="flex flex-row gap-4">
                    <button onClick={ () => doSubmit () }>Submit</button>
                    <button onClick={ () => navigate ( "/admin" ) }>Back</button>
                </div>
            </>
}

export default Funds;